<script setup>
import {ref, onMounted, onUnmounted, computed} from 'vue';

const props = defineProps({
  label: String,
  options: Array,
  modelValue: Array,
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(false);
const dropdownRef = ref(null);

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function handleClickOutside(event) {
  if (isOpen.value && dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

// Computed property for v-model
const checkedValues = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});
</script>

<template>
  <div class="checkbox-dropdown" ref="dropdownRef">
    <div class="dropdown-header" @click="toggleDropdown">
      <span>{{ label }}</span>
      <span class="arrow" :class="{ open: isOpen }"></span>
    </div>
    <div class="dropdown-list" v-if="isOpen">
      <label v-for="option in options" :key="option.value">
        <input
            type="checkbox"
            :value="option.value"
            v-model="checkedValues"
        />
        {{ option.label }}
      </label>
    </div>
  </div>
</template>


<style scoped>
.checkbox-dropdown {
  position: relative;
  width: 100%;
  margin-bottom: 16px;

}

.dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f2f2f2;
  cursor: pointer;
  border-radius: 4px;
}

.dropdown-header:hover {
  background: #e6e6e6;
}

.arrow {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #333;
  transition: transform 0.2s;
}

.arrow.open {
  transform: rotate(180deg);
}

.dropdown-list {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 4px;
  border-radius: 4px;
  padding-bottom: 1rem;
}

.dropdown-list label {
  display: flex;
  align-items: center;
  padding: 8px 12px;
}

.dropdown-list label:hover {
  background: #f9f9f9;
}

.dropdown-list input {
  margin-right: 8px;
}

/* Responsive Styles */
@media (max-width: 600px) {
  .dropdown-header {
    padding: 10px;
  }

  .dropdown-list label {
    padding: 6px 10px;
  }
}
</style>
